import { Global, css } from '@emotion/react';

const Fonts = () => (
    <Global
        styles={css`
            @font-face {
                font-family: 'IBM Plex Sans';
                src: url('../fonts/IBMPlexSans-Light.ttf') format('truetype');
                font-weight: 300;
                font-style: normal;
            }

            @font-face {
                font-family: 'IBM Plex Sans';
                src: url('../fonts/IBMPlexSans-LightItalic.ttf') format('truetype');
                font-weight: 300;
                font-style: italic;
            }

            @font-face {
                font-family: 'IBM Plex Sans';
                src: url('../fonts/IBMPlexSans-Regular.ttf') format('truetype');
                font-weight: 400;
                font-style: normal;
            }

            @font-face {
                font-family: 'IBM Plex Sans';
                src: url('../fonts/IBMPlexSans-Italic.ttf') format('truetype');
                font-weight: 400;
                font-style: italic;
            }

            @font-face {
                font-family: 'IBM Plex Sans';
                src: url('../fonts/IBMPlexSans-Medium.ttf') format('truetype');
                font-weight: 500;
                font-style: normal;
            }

            @font-face {
                font-family: 'IBM Plex Sans';
                src: url('../fonts/IBMPlexSans-MediumItalic.ttf') format('truetype');
                font-weight: 500;
                font-style: italic;
            }

            @font-face {
                font-family: 'IBM Plex Sans';
                src: url('../fonts/IBMPlexSans-SemiBold.ttf') format('truetype');
                font-weight: 600;
                font-style: normal;
            }

            @font-face {
                font-family: 'IBM Plex Sans';
                src: url('../fonts/IBMPlexSans-SemiBoldItalic.ttf') format('truetype');
                font-weight: 600;
                font-style: italic;
            }

            @font-face {
                font-family: 'IBM Plex Sans';
                src: url('../fonts/IBMPlexSans-Bold.ttf') format('truetype');
                font-weight: 700;
                font-style: normal;
            }

            @font-face {
                font-family: 'IBM Plex Sans';
                src: url('../fonts/IBMPlexSans-BoldItalic.ttf') format('truetype');
                font-weight: 700;
                font-style: italic;
            }
    `}
    />
);

export default Fonts;
